import Image from 'next/image';
import { useMemo } from 'react';

import useGetChainInfo from '@/hooks/useGetChainInfo';
import { getAddressScannerUrl, maskAddressValue } from '@/utils/format';

import { EventTriggerType, Trigger } from '../../domain';
import { TriggerExternalLinkDetail } from './components/TriggerExternalLinkDetail';
import { TriggerType } from './components/TriggerType';

type Props = {
  trigger: Trigger;
  triggerType: EventTriggerType;
};

export const TokenHolderTriggerDetails = ({ trigger, triggerType }: Props) => {
  const { getChainIconUrl } = useGetChainInfo();

  const scannerUrl = useMemo(() => {
    if (!trigger.contracts?.[0]) return '';

    const contract = trigger.contracts[0];
    return getAddressScannerUrl('chainId', contract.chainId, contract.address) || '';
  }, [trigger.contracts]);

  const chainIconUrl = useMemo(() => {
    if (!trigger.contracts?.[0]) return '';
    return getChainIconUrl(trigger.contracts[0].chainId) || '';
  }, [trigger.contracts, getChainIconUrl]);

  return (
    <div className="tw:flex tw:flex-row tw:gap-6">
      <TriggerType eventType={triggerType} />

      <TriggerExternalLinkDetail
        label="Contract"
        value={
          <div className="tw:flex tw:flex-row tw:gap-1 tw:items-center">
            {chainIconUrl && (
              <Image src={chainIconUrl} width={12} height={12} alt={trigger.contracts?.[0]?.network || 'chain'} />
            )}
            <span>{maskAddressValue(trigger.contracts?.[0]?.address ?? '') ?? ''}</span>
          </div>
        }
        href={scannerUrl}
      />
    </div>
  );
};
